<div class="container my-4">
  <div class="topheadtitle">
    <h4>eCitation Users</h4>
  </div>

  <div class="saerch-section d-flex justify-content-between mb-2">
    <div class="row g-3 align-items-center">
      <div class="col-auto">
        <label for="inputPassword6" class="col-form-label">Filter</label>
      </div>
      <div class="col-auto">
        <input type="text" (keyup)="filterItems(searchQuery.value)" #searchQuery id="inputPassword6"
          class="form-control" placeholder="Search for any text" />
        </div>
      </div>

      @if (userTypeView === 'S'|| userTypeView === 'V'|| userTypeView === 'D') {
        <div class="new-btn">
          <button class="btn btn-outline-secondary btn-sm" type="button" (click)="edit(contentda,'add',null)">
            New <i class="fa-sharp fa-solid fa-plus" aria-hidden="true"></i>
          </button>
        </div>
      }
    </div>

    <main class="table-container w-100">
      <table class="table">
        <caption>eCitation list of users.</caption>
        <thead>
          <tr>
            <th scope="col">Email</th>
            <th scope="col">
              <button type="button" class="btn btn-link p-0 sort-header" aria-label="Sort by Name"
                (click)="onSort($event,'firstName',true)">
                Name <i class="fa fa-sort" aria-hidden="true"></i>
              </button>
            </th>

            <th scope="col">
              <button type="button" class="btn btn-link p-0 sort-header" aria-label="Sort by Agency"
                (click)="onSort($event,'agency',true)">
                Agency <i class="fa fa-sort" aria-hidden="true"></i>
              </button>
            </th>

            <th scope="col">Role</th>
            <th scope="col">Status</th>
            @if (userTypeView === 'S'|| userTypeView === 'V'|| userTypeView === 'D') {
              <th scope="col">Edit</th>
            }
            <th scope="col" width="100">Unlock</th>
            @if (userTypeView === 'S'|| userTypeView === 'V'|| userTypeView === 'D') {
              <th scope="col" width="100">
              Enable/Disable</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (item of getItems(); track item) {
            <tr>
              <td>{{item.email}}</td>
              <td>{{item.firstName}} {{item.lastName}}</td>
              <td>{{item.agency}}</td>
              <td>{{item.roleName}}</td>
              <td>
                @if (item.acctLocked==='Y') {
                  {{item.acctLocked==='Y' ? 'Locked':''}}
                }
                @if (item.acctActive==='Y') {
                  {{item.acctActive==='Y' ? 'Active':''}}
                }
                @if ( item.acctActive==='N' && item.acctLocked==='N') {
                  {{item.acctActive==='N' ? 'Inactive':''}}
                }
              </td>
              @if (userTypeView === 'S'|| userTypeView === 'V'|| userTypeView === 'D') {
                <td>
                  <button type="button" class="icon-button" [attr.aria-label]="'Edit ' + item.email"
                    (click)="edit(contentda,'edit',item.userId)">
                    <i class="fa-sharp fa-solid fa-pen-to-square" aria-hidden="true"></i>
                    <span class="visually-hidden">Edit {{ item.email }}</span>
                  </button>
                </td>
              }
              <td class="text-center">
                <div class="form-check d-flex justify-content-center form-switch">
                  <input class="form-check-input" [disabled]="item.acctLocked==='N'" type="checkbox"
                    aria-label="Unlock user" (change)="unlockUser($event,item.userName)" title="Unlock User"
                    aria-checked="false" [checked]="item.acctLocked==='N'" />
                  </div>
                </td>
                @if (userTypeView === 'S'|| userTypeView === 'V'|| userTypeView === 'D') {
                  <td class="text-center">
                    <div class="form-check d-flex justify-content-center form-switch">
                      <input class="form-check-input" type="checkbox" aria-label="Enable or disable user" aria-checked="false"
                        [disabled]="item.acctLocked==='Y'" (change)="enableDisableUser($event,item.userName )"
                        title="Enable or Disable User" [checked]="item.acctActive==='Y'" />
                      </div>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>

          <div class="d-flex justify-content-between align-items-center">
            <div class="w-33">
              <span>
                {{listAllUserDetails.length}} items found, displaying
                {{(currentPage*10 > listAllUserDetails.length )? listAllUserDetails.length : currentPage*10 }}
                of {{listAllUserDetails.length}}
              </span>
            </div>
            <ngb-pagination [collectionSize]="listAllUserDetails.length" [(page)]="currentPage" [ellipses]="true"
              [maxSize]="10" (pageChange)="onPageChange(currentPage)" [pageSize]="10" [boundaryLinks]="true"
            aria-label="Users list pagination"></ngb-pagination>
            <div class="w-33"></div>
          </div>
        </main>
      </div>

      <!-- add and edit user details modal -->
      <ng-template class="modal-dialog modal-lg" #contentda let-modal>
        <div class="step-4" aria-modal="true" aria-labelledby="modal-basic-title">
          <div class="modal-header">
            <h4 style="font-size: 15px;" class="modal-title" id="modal-basic-title">{{mode =='add'?'Add New':'Edit'}} User
            </h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
          </div>

          <div class="modal-body">
            @if (alert) {
              <div class="alert alert-danger" role="alert">{{alert.message}}</div>
            }

            <div class="d-flex align-items-center justify-content-center">
              <div class="form">
                <form [formGroup]="editUserForm" (ngSubmit)="updateUser()">
                  <div class="mb-2">
                    <label for="firstName" class="form-label">First Name</label><span class="c-red">*</span>
                    <input id="firstName" type="text" formControlName="firstName" class="form-control" placeholder="John" />
                    <app-control-message [control]="editUserForm.get('firstName')"
                    [message]="{required: 'Field is requried'}"></app-control-message>
                  </div>

                  <div class="mb-2">
                    <label for="lastName" class="form-label">Last Name</label><span class="c-red">*</span>
                    <input id="lastName" type="text" formControlName="lastName" class="form-control" placeholder="Doe" />
                    <app-control-message [control]="editUserForm.get('lastName')"
                    [message]="{required: 'Field is requried'}"></app-control-message>
                  </div>

                  <div class="mb-2">
                    <label for="username" class="form-label">User Name</label><span class="c-red">*</span>
                    <input id="username" type="text" formControlName="username" class="form-control" placeholder="aBcD1234" />
                    <app-control-message [control]="editUserForm.get('username')"
                    [message]="{required: 'Field is requried'}"></app-control-message>
                  </div>

                  <div class="mb-2">
                    <label for="email" class="form-label">Email address</label><span class="c-red">*</span>
                    <input id="email" type="email" formControlName="email" class="form-control"
                      placeholder="johndoe@gmail.com" autocomplete="email"/>
                      <app-control-message [control]="editUserForm.get('email')"
                      [message]="{required: 'Field is requried',email:'Enter a valid email address'}"></app-control-message>
                    </div>

                    <div class="mb-2">
                      <span class="form-label">Password</span><span class="c-red"></span>
                      <div class="input-group">
                        @if (editUserForm?.get('password')?.value != null) {
                          <input id="password" type="text" readonly
                            formControlName="password" class="form-control" placeholder="Password" />
                        }
                        <button class="btn btn-outline-secondary" type="button" placement="top" triggers="mouseenter:mouseleave"
                          ngbPopover="Warning - Make sure you copy the above password now. We don't store it and you will not be able to see it again."
                          (click)="generatePass('edit')">
                          Generate Password
                        </button>
                      </div>
                      <app-control-message [control]="editUserForm.get('password')"
                      [message]="{required: 'Field is requried'}"></app-control-message>
                    </div>

                    @if (userType=='Court' ) {
                      <div class="mb-3">
                        <label for="agency" class="form-label">Agency</label><span class="c-red">*</span>
                        <select id="agency" formControlName="agency" class="form-select form-select-sm selectMax">
                          @for (item of listAllAgency; track item) {
                            <option [value]="item.courtName">
                              {{item.courtName}}
                            </option>
                          }
                        </select>
                        <app-control-message [control]="editUserForm.get('agency')"
                        [message]="{required: 'Field is requried'}"></app-control-message>
                      </div>
                    }

                    @if (userType=='Vendor' ) {
                      <div class="mb-3">
                        <label for="agencyVendor" class="form-label">Agency</label><span class="c-red">*</span>
                        <select id="agencyVendor" formControlName="agency" class="form-select form-select-sm selectMax">
                          @for (item of listAllAgency; track item) {
                            <option [value]="item.vendorName">
                              {{item.vendorName }}
                            </option>
                          }
                        </select>
                        <app-control-message [control]="editUserForm.get('agency')"
                        [message]="{required: 'Field is requried'}"></app-control-message>
                      </div>
                    }

                    @if (userType=='Destination' ) {
                      <div class="mb-3">
                        <label for="agencyDestination" class="form-label">Agency</label><span class="c-red">*</span>
                        <select id="agencyDestination" formControlName="agency" class="form-select form-select-sm selectMax">
                          @for (item of listAllAgency; track item) {
                            <option [value]="item.contactPerson">
                              {{item.contactPerson }}
                            </option>
                          }
                        </select>
                        <app-control-message [control]="editUserForm.get('agency')"
                        [message]="{required: 'Field is requried'}"></app-control-message>
                      </div>
                    }

                    <div class="mb-2">
                      <label for="userRole" class="form-label">User Role</label><span class="c-red">*</span>
                      <select id="userRole" formControlName="userRole" class="form-select form-select-sm">
                        @for (item of listAllUserRoles; track item) {
                          <option [value]="item.roleName">
                            {{item.roleName}}
                          </option>
                        }
                      </select>
                      <app-control-message [control]="editUserForm.get('userRole')"
                      [message]="{required: 'Field is requried'}"></app-control-message>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-danger btn-sm me-2" (click)="modal.close()">Cancel</button>
                      <button type="submit" [disabled]="!editUserForm.dirty" class="btn btn-primary btn-sm">
                        {{mode=='add'?'Submit':'Update'}}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

        </ng-template>